/** Add / edit a company. */
import { useState } from 'react';
import { useApp } from '../../store/AppContext.jsx';
import { salesTeam } from '../../domain/crm.js';
import Sheet, { Group, Field, OptionSelect } from '../Sheet.jsx';
import AskAI from "../AskAI.jsx";

export default function CompanySheet({ id, onClose }) {
  const { S, crm, saveCompany, toast } = useApp();
  const existing = id ? crm.companies.find(c => c.id === id) : null;

  const [form, setForm] = useState(() => existing || {
    name: '', industry: '', size: '', city: '', owner: '', web: ''
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = () => {
    if (!String(form.name).trim()) { toast('Name the company'); return; }
    saveCompany(id, { ...form, name: String(form.name).trim() });
    onClose();
  };

  return (
    <Sheet
      icon="building"
      tone="g-cyan"
      title={id ? 'Edit company' : 'New company'}
      onClose={onClose}
      onSave={save}
      saveLabel="Save company"
      footerLeft={id ? <AskAI module="company" id={id} subject={form.name} ghost label="Read this account" /> : null}
    >
      <Group>Company</Group>

      <Field label="Name" wide>
        <input autoFocus value={form.name || ''} onChange={e => set('name', e.target.value)} />
      </Field>
      <Field label="Industry">
        <OptionSelect value={form.industry} onChange={v => set('industry', v)} options={S.industries || []} blank="" />
      </Field>
      <Field label="Size">
        <input value={form.size || ''} onChange={e => set('size', e.target.value)} />
      </Field>
      <Field label="City">
        <input value={form.city || ''} onChange={e => set('city', e.target.value)} />
      </Field>
      <Field label="Owner">
        <OptionSelect value={form.owner} onChange={v => set('owner', v)} options={salesTeam(S, crm, form.owner)} blank="" />
      </Field>
      <Field label="Website" wide>
        <input value={form.web || ''} onChange={e => set('web', e.target.value)} />
      </Field>
    </Sheet>
  );
}
